// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfe-beh-smart-groups-select-action {
  width: 196px;
  margin-block-start: var(--neon-2_15_0-spacing-large);
}

.mfe-beh-smart-groups-table-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-block-start: var(--neon-2_15_0-spacing-large);
}

.mfe-beh-smart-groups-table-header-actions {
  display: flex;
  gap: var(--neon-2_15_0-spacing-large);
  margin-block-start: var(--neon-2_15_0-spacing-large);
}

.mfe-beh-smart-groups-table-header-buttons {
  display: flex;
  align-items: flex-end;
}

.mfe-beh-smart-groups-last-setting {
  display: flex;
  align-items: center;
  margin-block-end: 4px;
}

.mfe-beh-smart-groups-line {
  margin-inline: var(--neon-2_15_0-spacing-small);
  width: 1px;
  height: 21px;
}

/* Reset some default table styles */
.mfe-beh-smart-groups-consequence_table table {
  border-collapse: collapse;
  width: 100%;
  background-color: #fff;
}

/* Style table headers */
.mfe-beh-smart-groups-consequence_table th {
  border: none;
}

/* Style even rows */
.mfe-beh-smart-groups-consequence_table tbody tr:nth-child(even) {
  background: none;
}

/* Style odd rows */
.mfe-beh-smart-groups-consequence_table tbody tr:nth-child(odd) {
  background: none;
}

/* Style table cells */
.mfe-beh-smart-groups-consequence_table td {
  border: none;
  text-align: left;
  /* Default horizontal alignment */
  vertical-align: middle;
  /* Default vertical alignment */
}

/* Style checkboxes in the table */
.mfe-beh-smart-groups-consequence_table td input[type=checkbox] {
  margin: 0;
  padding: 0;
}

/* Style table headers with sorting icons */
/* Styling for the sorting icon */
.mfe-beh-smart-groups-consequence_table th .neon-icon {
  margin-left: 5px;
}

/* Remove default list styling for data labels */
.mfe-beh-smart-groups-consequence_table td[data-label]::before {
  content: attr(data-label) ": ";
  display: none;
  /* Hide from visual display */
}

.mfe-beh-smart-groups-planet-all-checkbox-list-parent span {
  position: absolute;
  clip-path: polygon(0 0, 0 0, 0 0);
}

/* Visually hidden class for accessibility */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: polygon(0 0, 0 0, 0 0);
  white-space: nowrap;
  border: 0;
}

/* Screen reader-only text for checkboxes */
.mfe-beh-smart-groups-consequence_table td .visually-hidden {
  display: inline;
}

/* Remove default bullet points for unordered lists */
.mfe-beh-smart-groups-consequence_table ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Style selected rows for better visibility */
.mfe-beh-smart-groups-consequence_table tbody tr.selected {
  color: #fff;
}

/* Style the table container */
.mfe-beh-smart-groups-consequence_table {
  max-width: 100%;
  width: -webkit-fill-available;
  height: calc(100vh - 285px);
  overflow-x: auto;
  margin-top: 16px;
  overflow-y: auto;
}

/* Add hover effect on table rows */
.mfe-beh-smart-groups-consequence_table tbody tr:hover {
  background: none;
}

/* Ensure proper contrast for text */
/* Define specific column widths */
.mfe-beh-smart-groups-consequence_table th:nth-child(1),
.mfe-beh-smart-groups-consequence_table td:nth-child(1) {
  width: 3.87%;
  /* 48px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(2),
.mfe-beh-smart-groups-consequence_table td:nth-child(2) {
  width: 18.23%;
  /* 226px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(2) div,
.mfe-beh-smart-groups-consequence_table th:nth-child(3) div,
.mfe-beh-smart-groups-consequence_table th:nth-child(7) div {
  width: 100%;
  display: flex;
  align-items: center;
}

.mfe-beh-smart-groups-consequence_table th:nth-child(2) div span,
.mfe-beh-smart-groups-consequence_table th:nth-child(3) div span,
.mfe-beh-smart-groups-consequence_table th:nth-child(7) div span {
  display: flex;
  margin-inline-start: 7px;
  /* Adjust the margin as needed */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(3),
.mfe-beh-smart-groups-consequence_table td:nth-child(3) {
  width: 11.29%;
  /* 140px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(4),
.mfe-beh-smart-groups-consequence_table td:nth-child(4) {
  width: 11.85%;
  /* 147px / 1240px */
  text-align: center;
}

.mfe-beh-smart-groups-consequence_table th:nth-child(5),
.mfe-beh-smart-groups-consequence_table td:nth-child(5) {
  width: 9.68%;
  /* 120px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(6),
.mfe-beh-smart-groups-consequence_table td:nth-child(6) {
  width: 19.52%;
  /* 241px / 1240px */
}

.mfe-beh-smart-groups-consequence_table td:nth-child(6) {
  max-width: 80px;
  /* Adjust this value to control the maximum visible width */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(7),
.mfe-beh-smart-groups-consequence_table td:nth-child(7) {
  width: 14.52%;
  /* 180px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(8),
.mfe-beh-smart-groups-consequence_table td:nth-child(8) {
  width: 11.13%;
  /* 138px / 1240px */
  text-align: center;
}

.mfe-beh-smart-groups-ct_positivity {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.mfe-beh-smart-groups-ct_positivity p {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  margin: 0px;
}

.mfe-beh-smart-groups-ct_positivity span {
  display: flex;
  width: 114px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--text-color-dark, #333);
  text-align: center;
  color: var(--neon-2_15_0-color-black);
  font: var(--neon-2_15_0-font-1);
}

.mfe-beh-smart-groups-ct_positivity #mfe-beh-smart-groups-consequence_bar-only-example {
  min-width: 150px !important;
}

.mfe-beh-smart-groups-planet-all-checkbox-list-parent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mfe-beh-smart-groups-smart-group-table-error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
}

.mfe-beh-smart-groups-smart-group-table-loader-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
}

.mfe-beh-smart-groups-smart-group-table-empty-state {
  margin-block-start: 50px;
}

.mfe-beh-smart-groups-pagination-parent {
  background-color: #fff;
  margin-top: 5px;
}

.mfe-beh-smart-groups-system-message-container {
  width: 100%;
  margin-top: 9px;
  margin-bottom: -9px;
}

.mfe-beh-smart-groups-system-message-action {
  width: 70%;
}`, "",{"version":3,"sources":["webpack://./components/smart-groups/smart-group-table/smart-group-table.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,oDAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,oDAAA;AACJ;;AAEA;EACI,aAAA;EACA,qCAAA;EACA,oDAAA;AACJ;;AAEA;EACI,aAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,+CAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAGA,oCAAA;AACA;EACI,yBAAA;EACA,WAAA;EACA,sBAAA;AAAJ;;AAGA,wBAAA;AACA;EAGI,YAAA;AAFJ;;AAKA,oBAAA;AACA;EACI,gBAAA;AAFJ;;AAKA,mBAAA;AACA;EACI,gBAAA;AAFJ;;AAKA,sBAAA;AACA;EAEI,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,sBAAA;EACA,+BAAA;AAHJ;;AAMA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;AAHJ;;AAQA,2CAAA;AAMA,iCAAA;AACA;EACI,gBAAA;AAVJ;;AAaA,gDAAA;AACA;EACI,8BAAA;EACA,aAAA;EACA,6BAAA;AAVJ;;AAgBA;EACI,kBAAA;EACA,iCAAA;AAbJ;;AAgBA,4CAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,SAAA;AAbJ;;AAgBA,2CAAA;AACA;EACI,eAAA;AAbJ;;AAgBA,qDAAA;AACA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AAbJ;;AAgBA,8CAAA;AACA;EAEI,WAAA;AAdJ;;AAiBA,8BAAA;AACA;EACI,eAAA;EACA,6BAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAdJ;;AAiBA,mCAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,oCAAA;AAMA,kCAAA;AACA;;EAEI,YAAA;EACA,kBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;;EAGI,WAAA;EACA,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;;EAGI,aAAA;EACA,wBAAA;EACA,gCAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;;AAsBA;;EAEI,YAAA;EACA,mBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,eAAA;EACA,2DAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;;AAsBA;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mCAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;AAnBJ;;AAqBA;EACI,2BAAA;AAlBJ;;AAoBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBJ;;AAmBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAhBJ;;AAkBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAfJ;;AAkBA;EACI,wBAAA;AAfJ;;AAkBA;EACI,sBAAA;EACA,eAAA;AAfJ;;AAkBA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AAfJ;;AAkBA;EACI,UAAA;AAfJ","sourcesContent":[".__mfe__select-action {\n    width: 196px;\n    margin-block-start: var(--__neon__spacing-large);\n}\n\n.__mfe__table-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-block-start: var(--__neon__spacing-large);\n}\n\n.__mfe__table-header-actions {\n    display: flex;\n    gap: var(--__neon__spacing-large);\n    margin-block-start: var(--__neon__spacing-large);\n}\n\n.__mfe__table-header-buttons {\n    display: flex;\n    align-items: flex-end;\n}\n\n.__mfe__last-setting {\n    display: flex;\n    align-items: center;\n    margin-block-end: 4px;\n}\n\n.__mfe__line {\n    margin-inline: var(--__neon__spacing-small);\n    width: 1px;\n    height: 21px;\n}\n\n// css by Abhinav\n/* Reset some default table styles */\n.__mfe__consequence_table table {\n    border-collapse: collapse;\n    width: 100%;\n    background-color: #fff;\n}\n\n/* Style table headers */\n.__mfe__consequence_table th {\n    // text-align: left;\n    // padding: 10px;\n    border: none;\n}\n\n/* Style even rows */\n.__mfe__consequence_table tbody tr:nth-child(even) {\n    background: none;\n}\n\n/* Style odd rows */\n.__mfe__consequence_table tbody tr:nth-child(odd) {\n    background: none;\n}\n\n/* Style table cells */\n.__mfe__consequence_table td {\n    // padding: 10px;\n    border: none;\n    text-align: left;\n    /* Default horizontal alignment */\n    vertical-align: middle;\n    /* Default vertical alignment */\n}\n\n/* Style checkboxes in the table */\n.__mfe__consequence_table td input[type=\"checkbox\"] {\n    margin: 0;\n    padding: 0;\n    // width: 16px;\n    // height: 16px;\n}\n\n/* Style table headers with sorting icons */\n// .__mfe__consequence_table th span {\n//     display: flex;\n//     align-items: center;\n// }\n\n/* Styling for the sorting icon */\n.__mfe__consequence_table th .neon-icon {\n    margin-left: 5px;\n}\n\n/* Remove default list styling for data labels */\n.__mfe__consequence_table td[data-label]::before {\n    content: attr(data-label) \": \";\n    display: none;\n    /* Hide from visual display */\n}\n\n// Visually hidding the table checkbox label \n// so that it is not visible on webpage \n// but readable by Narrator for accessibility\n.__mfe__planet-all-checkbox-list-parent span {\n    position: absolute;\n    clip-path: polygon(0 0, 0 0, 0 0);\n}\n\n/* Visually hidden class for accessibility */\n.visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip-path: polygon(0 0, 0 0, 0 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n/* Screen reader-only text for checkboxes */\n.__mfe__consequence_table td .visually-hidden {\n    display: inline;\n}\n\n/* Remove default bullet points for unordered lists */\n.__mfe__consequence_table ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n/* Style selected rows for better visibility */\n.__mfe__consequence_table tbody tr.selected {\n    // background-color: #007bff;\n    color: #fff;\n}\n\n/* Style the table container */\n.__mfe__consequence_table {\n    max-width: 100%;\n    width: -webkit-fill-available;\n    height: calc(100vh - 285px);\n    overflow-x: auto;\n    margin-top: 16px;\n    overflow-y: auto;\n}\n\n/* Add hover effect on table rows */\n.__mfe__consequence_table tbody tr:hover {\n    background: none;\n}\n\n/* Ensure proper contrast for text */\n// .__mfe__consequence_table th,\n// .__mfe__consequence_table td {\n//     color: #333;\n// }\n\n/* Define specific column widths */\n.__mfe__consequence_table th:nth-child(1),\n.__mfe__consequence_table td:nth-child(1) {\n    width: 3.87%;\n    /* 48px / 1240px */\n}\n\n.__mfe__consequence_table th:nth-child(2),\n.__mfe__consequence_table td:nth-child(2) {\n    width: 18.23%;\n    /* 226px / 1240px */\n}\n\n.__mfe__consequence_table th:nth-child(2) div,\n.__mfe__consequence_table th:nth-child(3) div,\n.__mfe__consequence_table th:nth-child(7) div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.__mfe__consequence_table th:nth-child(2) div span,\n.__mfe__consequence_table th:nth-child(3) div span,\n.__mfe__consequence_table th:nth-child(7) div span {\n    display: flex;\n    margin-inline-start: 7px;\n    /* Adjust the margin as needed */\n}\n\n.__mfe__consequence_table th:nth-child(3),\n.__mfe__consequence_table td:nth-child(3) {\n    width: 11.29%;\n    /* 140px / 1240px */\n}\n\n.__mfe__consequence_table th:nth-child(4),\n.__mfe__consequence_table td:nth-child(4) {\n    width: 11.85%;\n    /* 147px / 1240px */\n    text-align: center;\n}\n\n.__mfe__consequence_table th:nth-child(5),\n.__mfe__consequence_table td:nth-child(5) {\n    width: 9.68%;\n    /* 120px / 1240px */\n}\n\n.__mfe__consequence_table th:nth-child(6),\n.__mfe__consequence_table td:nth-child(6) {\n    width: 19.52%;\n    /* 241px / 1240px */\n}\n\n.__mfe__consequence_table td:nth-child(6) {\n    max-width: 80px;\n    /* Adjust this value to control the maximum visible width */\n}\n\n.__mfe__consequence_table th:nth-child(7),\n.__mfe__consequence_table td:nth-child(7) {\n    width: 14.52%;\n    /* 180px / 1240px */\n}\n\n.__mfe__consequence_table th:nth-child(8),\n.__mfe__consequence_table td:nth-child(8) {\n    width: 11.13%;\n    /* 138px / 1240px */\n    text-align: center;\n}\n\n.__mfe__ct_positivity {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.__mfe__ct_positivity p {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    margin: 0px;\n}\n\n.__mfe__ct_positivity span {\n    display: flex;\n    width: 114px;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    color: var(--text-color-dark, #333);\n    text-align: center;\n    color: var(--__neon__color-black);\n    font: var(--__neon__font-1);\n}\n.__mfe__ct_positivity #__mfe__consequence_bar-only-example{\n    min-width:150px !important;\n}\n.__mfe__planet-all-checkbox-list-parent{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.__mfe__smart-group-table-error-state{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 80px;\n}\n.__mfe__smart-group-table-loader-state{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 120px;\n}\n\n.__mfe__smart-group-table-empty-state{\n    margin-block-start: 50px;\n}\n\n.__mfe__pagination-parent{\n    background-color: #fff;\n    margin-top: 5px;\n}\n\n.__mfe__system-message-container{\n    width:100%;\n    margin-top: 9px;\n    margin-bottom: -9px;\n}\n\n.__mfe__system-message-action{\n    width:70%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
